import React from 'react'
import SVG from 'react-inlinesvg'
import teamIcon from '@icons/olympinfo/olympinfo-team'
import earthIcon from '@icons/olympinfo/olympinfo-earth'
import certIcon from '@icons/olympinfo/olympinfo-sert'
import { h } from '@app/helpers/translationHelper'

const OlympInfo = (props) => {
  return (
    <section className="section olympinfo__section">
      <div className="grid">
        <div className="olympinfo__image" />
      </div>
      <div className="plate plate--info plate--xl m-0" style={{ border: 'none' }}>
        <h1 className="plate-heading plate-heading--left f--purple mb-1"
          dangerouslySetInnerHTML={ h('landing.olympinfo.heading') }
        />

        <div className="w-flex-layout w-flex-layout--columns">
          <div className="h-flex-layout h-flex-layout--row-inline h-flex-layout--ai-center">
            <SVG src={teamIcon} />
            <div className="f--l f--default ml-gutter-m">
              { I18n.t('landing.olympinfo.paragraph_1') }
            </div>
          </div>

          <div className="h-flex-layout h-flex-layout--row-inline h-flex-layout--ai-center">
            <SVG src={earthIcon} />
            <div className="f--l f--default ml-gutter-m">
              { I18n.t('landing.olympinfo.paragraph_2') }
            </div>
          </div>

          <div className="h-flex-layout h-flex-layout--row-inline h-flex-layout--ai-center">
            <SVG src={certIcon} />
            <div className="f--l f--default ml-gutter-m">
              { I18n.t('landing.olympinfo.paragraph_3') }
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default OlympInfo
